/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_PlayerInputs */

const en_video_player = /** @type {(inputs: Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Player`)
};

const es_video_player = /** @type {(inputs: Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproductor de video`)
};

const fr_video_player = /** @type {(inputs: Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecteur vidéo`)
};

const de_video_player = /** @type {(inputs: Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video-Player`)
};

const ja_video_player = /** @type {(inputs: Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオプレーヤー`)
};

const zh_video_player = /** @type {(inputs: Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频播放器`)
};

const ar_video_player = /** @type {(inputs: Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشغل الفيديو`)
};

const id_video_player = /** @type {(inputs: Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemutar Video`)
};

const it_video_player = /** @type {(inputs: Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettore Video`)
};

const ru_video_player = /** @type {(inputs: Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеоплеер`)
};

const pt_video_player = /** @type {(inputs: Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Player de Vídeo`)
};

const ko_video_player = /** @type {(inputs: Video_PlayerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비디오 플레이어`)
};

/**
* | output |
* | --- |
* | "Video Player" |
*
* @param {Video_PlayerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const video_player = /** @type {((inputs?: Video_PlayerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_PlayerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_video_player(inputs)
	if (locale === "es") return es_video_player(inputs)
	if (locale === "fr") return fr_video_player(inputs)
	if (locale === "de") return de_video_player(inputs)
	if (locale === "ja") return ja_video_player(inputs)
	if (locale === "zh") return zh_video_player(inputs)
	if (locale === "ar") return ar_video_player(inputs)
	if (locale === "id") return id_video_player(inputs)
	if (locale === "it") return it_video_player(inputs)
	if (locale === "ru") return ru_video_player(inputs)
	if (locale === "pt") return pt_video_player(inputs)
	return ko_video_player(inputs)
});